import React, { useEffect, useState } from "react"

import translations from "../../utils/translations"

import applyButton from "../../assets/images/applyButton.png"
import applyButtonActive from "../../assets/images/applyButtonActive.png"
import applyButtonDeactive from "../../assets/images/applyButtonDeactive.png"
import moment from "moment-timezone"
import button1 from "../../assets/images/button1.png"
import { getApiResponse } from "../../utils/nativeUtils"

function EventButton({
    profile,
    onUpperClick,
    upperState,
    setAppsflyerTrackingCode,
    setIsAfterRegistedVisible,
    setIsLoginModalVisible,
    setIsNoTargetModalVisible,
    setIsApplyModalVisible,
    showToast,
    setIsInnerModalVisible,
    setIsDone,
    isDone,
    setImageSrc,
    imageSrc,
}) {
    const [profileRegisterDateTime, setProfileRegisterDateTime] = useState(profile?.profileRegisterDateTime)

    useEffect(
        () => {
            setProfileRegisterDateTime(profile?.profileRegisterDateTime)
            renderButton()
        },
        [],
        profile
    )

    const buttonClicked = () => {
        if (!upperState) {
            // 버튼 스테이스 변경부분
            if (profile?.point < 0) {
                setImageSrc(applyButtonDeactive)
                setIsDone(true)
            } else if (profile?.sendYn === "Y") {
                setImageSrc(applyButtonDeactive)
                setIsDone(true)
            } else {
                setImageSrc(applyButtonActive)
            }
            onUpperClick()
        } else {
            if (!isDone) {
                setIsApplyModalVisible(true)
            } else {
                showToast(translations.TEXT.alreadyPurchase)
            }
        }
    }

    const renderButton = () => {
        const selectedDateTime = moment(profile?.profileRegisterDateTime)
        const comparisonDateTime = moment("2024-06-23T15:00:00")

        if (!profile?.profileId) {
            return <img src={applyButtonDeactive} alt="응모하기" onClick={() => {}} />
        } else if (profile?.remark === "NANO" || profile?.remark === "BOT") {
            return <img src={applyButtonDeactive} alt="응모하기" onClick={() => {}} />
        } else if (profile?.remark === "CELEBE_EMPLOYEE" || profile?.remark === "CELEBE_TEST" || profile?.remark === "CELEBePH_EMPLOYEE") {
            return <img src={applyButton} alt="응모하기" onClick={() => setIsInnerModalVisible(true)} />
        } else if (selectedDateTime.isAfter(comparisonDateTime)) {
            return <img src={applyButtonDeactive} alt="응모하기" onClick={() => {}} />
        } else if (profile?.sendYn === "Y") {
            return (
                <img
                    src={applyButtonDeactive}
                    alt="응모하기"
                    onClick={() => {
                        showToast(translations.TEXT.alreadyPurchase)
                    }}
                />
            )
        } else if (profile?.point === 0) {
            return (
                <img
                    src={applyButtonDeactive}
                    alt="응모하기"
                    onClick={() => {
                        showToast(translations.TEXT.eventPointZero)
                    }}
                />
            )
        }
        return <img src={imageSrc} alt="응모하기" onClick={buttonClicked} />
    }
    return renderButton()
}

export default EventButton
